import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputList from "../components/Form/UiInputList";

const tipoList = [
    { id: 1, title: 'Financeiro' },
    { id: 2, title: 'Orçamento' },
];

export default function TagForm(props: any){
    const methods = useForm({
        defaultValues: props.data
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <>
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <WindowBody>
                        <div className="row">
                            <UiInputText size={12} name="titulo" label="Título"/>
                            <UiInputText size={6} name="cor" label="Cor (hex)"/>
                            <UiInputList size={6} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo"/>
                        </div>
                    </WindowBody>

                    <WindowFooter>
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    )
}
